<script>
	export let safe_url = env.MOD_START_URL;
</script>

<div class="adventure">
	<h2>You find yoruself amidst deep woods with an atmosphere so still that it makes your skin crawl. A bone piercing scream from a direction you cannot discern hits your ears and you shrink behind the nearest tree.</h2>
	<a href={safe_url}>Get back to safety</a>
	<a href={location.pathname}>Stay here</a>
</div>


<style>
.adventure {
	display: flex;
	padding: 20vw;
	flex-direction: column;
	text-align: center;
}
</style>
